import React from "react";
import { View, Text, StyleSheet } from "react-native";
import Colors from "../../../Resources/Color";
import { BlockPlanificationConstants } from "../../../Resources/Constants";

const ClipboardVideoDot = ({ serie, isMobile }) => {
  const columnWidth = isMobile ? 20 : 24;
  const pillHeight = isMobile
    ? BlockPlanificationConstants.MOBILE_VALUE_PILL_HEIGHT
    : BlockPlanificationConstants.VALUE_PILL_HEIGHT;
  const dotSize = isMobile ? 7 : 8;

  const hasVideo = !!serie?.hasVideo;
  const requireVideo = !!serie?.requireVideo;

  const dotStyle = hasVideo
    ? [
        styles.videoDotFilled,
        { width: dotSize, height: dotSize, borderRadius: dotSize / 2 },
      ]
    : requireVideo
    ? [
        styles.videoDotOutline,
        { width: dotSize, height: dotSize, borderRadius: dotSize / 2 },
      ]
    : [
        styles.videoDotNone,
        { width: dotSize, height: dotSize, borderRadius: dotSize / 2 },
      ];

  return (
    <View
      style={[
        styles.setRowCameraColumn,
        { width: columnWidth, height: pillHeight },
      ]}
    >
      <View style={dotStyle} />
    </View>
  );
};

const ClipboardPriorityDot = ({ serie, isMobile }) => {
  const columnWidth = isMobile ? 20 : 24;
  const pillHeight = isMobile
    ? BlockPlanificationConstants.MOBILE_VALUE_PILL_HEIGHT
    : BlockPlanificationConstants.VALUE_PILL_HEIGHT;
  const dotSize = isMobile ? 7 : 8;

  if (!serie || serie.id === "placeholder") {
    return (
      <View
        style={[
          styles.setRowPriorityColumn,
          { width: columnWidth, height: pillHeight },
        ]}
      />
    );
  }

  const relevance = serie?.relevance;
  if (relevance !== 1 && relevance !== 2) {
    return (
      <View
        style={[
          styles.setRowPriorityColumn,
          { width: columnWidth, height: pillHeight },
        ]}
      />
    );
  }

  const getPriorityColor = () => {
    if (relevance === 1) return Colors.redColor;
    if (relevance === 2) return "#FFC107";
    return "transparent";
  };

  return (
    <View
      style={[
        styles.setRowPriorityColumn,
        { width: columnWidth, height: pillHeight },
      ]}
    >
      <View
        style={[
          styles.priorityDotSmall,
          {
            backgroundColor: getPriorityColor(),
            width: dotSize,
            height: dotSize,
            borderRadius: dotSize / 2,
          },
        ]}
      />
    </View>
  );
};

const ClipboardSetRow = ({ setItem, isMobile, showSetPriority }) => {
  const pillWidth = isMobile
    ? BlockPlanificationConstants.MOBILE_VALUE_PILL_WIDTH
    : BlockPlanificationConstants.VALUE_PILL_WIDTH;
  const pillHeight = isMobile
    ? BlockPlanificationConstants.MOBILE_VALUE_PILL_HEIGHT
    : BlockPlanificationConstants.VALUE_PILL_HEIGHT;

  const isZeroLike = (value) => {
    if (value === null || value === undefined) return false;
    if (value === "") return false;
    const n = Number(value);
    return Number.isFinite(n) && n === 0;
  };

  const formatTargetValue = (value) => {
    if (value === null || value === undefined) return "";
    if (value === "") return "";
    if (isZeroLike(value)) return "";
    return String(value);
  };

  return (
    <View style={[styles.setRow, isMobile && { gap: 6 }]}>
      <ClipboardVideoDot serie={setItem} isMobile={isMobile} />
      {showSetPriority && (
        <ClipboardPriorityDot serie={setItem} isMobile={isMobile} />
      )}
      <View
        style={[styles.valuePill, { width: pillWidth, height: pillHeight }]}
      >
        <Text
          style={[styles.valueText, isMobile && styles.valueTextMobile]}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {formatTargetValue(setItem?.targetWeight)}
        </Text>
      </View>
      <View
        style={[styles.valuePill, { width: pillWidth, height: pillHeight }]}
      >
        <Text
          style={[styles.valueText, isMobile && styles.valueTextMobile]}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {formatTargetValue(setItem?.targetReps)}
        </Text>
      </View>
      <View
        style={[styles.valuePill, { width: pillWidth, height: pillHeight }]}
      >
        <Text
          style={[styles.valueText, isMobile && styles.valueTextMobile]}
          numberOfLines={1}
          ellipsizeMode="tail"
        >
          {formatTargetValue(setItem?.targetRpe)}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  setRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: "rgba(255,255,255,0.08)",
    borderRadius: 8,
    width: "100%",
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  valuePill: {
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
    overflow: "hidden",
  },
  valueText: {
    fontSize: 11.5,
    color: Colors.whiteColor,
    fontWeight: "400",
    flexShrink: 1,
    minWidth: 0,
    textAlign: "center",
  },
  valueTextMobile: {
    fontSize: 11.5,
  },
  setRowCameraColumn: {
    alignItems: "center",
    justifyContent: "center",
  },
  videoDotFilled: {
    backgroundColor: Colors.lightGrayColor,
  },
  videoDotOutline: {
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.7)",
  },
  videoDotNone: {
    backgroundColor: "transparent",
  },
  setRowPriorityColumn: {
    alignItems: "center",
    justifyContent: "center",
  },
  priorityDotSmall: {},
});

export default ClipboardSetRow;
